import { createSlice } from "@reduxjs/toolkit";
import { getProductPriceByUniceId, getSingleProduct, getwebsiteProduct } from "../../reduxApi/website/ProductReduxApi";
import { getPartListDataAPi } from "../../reduxApi/website/MakeYearModel";

const ProductsSlice = createSlice({
  name: "product",
  initialState: {
    status: "idle",
    orders: [],
    product: [],
    singlPproduct: [],
    productPrice: [],
  },
  reducers: {
    deleteProductAction: (state, action) => {
      state.product = state.product.filter((item) => !action.payload.includes(item?.product?.ROWID));
    },
    updateProductAction: (state, action) => {
      const index = state.product.findIndex((item) => item.product.ROWID === action.payload.ROWID);
      if (index !== -1) {
        state.product[index] = { product: action.payload };
      }
    },
    addProductAction: (state, action) => {
      const temp = action.payload.formData;
      temp.ROWID = action.payload.ROWID;
      state.product.unshift(temp);
    },
    addFilteredProducts: (state, action) => {
      const temp = action.payload
      state.product = temp
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getwebsiteProduct.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getPartListDataAPi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // console.log(action.payload, "this is part list data");

        // state.product = action.payload.ShowMeThePartsDetail.partsdata;
        const allParts = action.payload.allParts;
        state.product = Array.isArray(allParts) ? allParts.slice().sort((a, b) => a.part_key.localeCompare(b.part_key)) : [];

        // console.log("Updated Product State:", state.product); // Debugging
      })
      .addCase(getSingleProduct.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.singlPproduct = action.payload.data.products;
      })
      .addCase(getProductPriceByUniceId.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.productPrice = action.payload.data;

        // console.log("Updated Product Price State:", state.productPrice); // Debugging
      });
  },
});

export const { deleteProductAction, updateProductAction, addProductAction,addFilteredProducts } = ProductsSlice.actions;
export default ProductsSlice.reducer;
